import { FC } from "react";
import { Tooltip } from "react-tooltip";
import { Button } from "../ButtonV2/Button";
import { Checkbox } from "../form/Checkbox/Checkbox";
import { ExitIcon } from "../SvgLibrary";
import { FeatureFlags, FEATURE_FLAGS, useFeatureFlag } from "./useFeatureFlag";

type FeatureFlagsListProps = {};

const FeatureFlagsList: FC<FeatureFlagsListProps> = () => {
  return (
    <div className="flex flex-col gap-3 px-2 py-3 ">
      <Tooltip id="feature-flag-tooltip" className="max-w-[400px]" />
      {Object.keys(FEATURE_FLAGS).map((key) => (
        <FeatureFlagItem key={key} featureFlagKey={key as FeatureFlags} />
      ))}
    </div>
  );
};

const FeatureFlagItem: FC<{ featureFlagKey: FeatureFlags }> = ({
  featureFlagKey
}) => {
  const featureFlag = FEATURE_FLAGS[featureFlagKey];
  const { isEnabled, setEnabled } = useFeatureFlag(featureFlagKey);

  return (
    <div className="flex items-center justify-between gap-2">
      <Checkbox
        checked={isEnabled}
        onChange={(e) => setEnabled(e.target.checked)}
        labelClassName="text-sm font-medium"
        label={featureFlag.label}
        wrapperClassName="flex items-center justify-center"
        wrapperProps={{
          "data-tooltip-id": "feature-flag-tooltip",
          "data-tooltip-content": featureFlag.description
        }}
      />
      <Button
        variant="iconOnly"
        size="small"
        onClick={() => setEnabled(undefined)}
        Icon={ExitIcon}
        data-tooltip-id="feature-flag-tooltip"
        data-tooltip-content="Reset feature flag to default"
      />
    </div>
  );
};

export default FeatureFlagsList;
